export class RefetchManager {
  private static instance: RefetchManager | undefined;
  private currentId: string | undefined = undefined;
  private readonly subscribers = new Map<string, () => void>();
  private readonly intervals = new Map<string, NodeJS.Timeout>();

  static getInstance(): RefetchManager {
    RefetchManager.instance = RefetchManager.instance ?? new RefetchManager();
    return RefetchManager.instance;
  }

  requestRefetch(id: string, callback: () => void) {
    this.subscribers.set(id, callback);

    if (!this.currentId) {
      this.startRefetch(id);
    }
  }

  private startRefetch(id: string) {
    this.currentId = id;
    const callback = this.subscribers.get(id);
    if (callback) {
      callback();
      const interval = setInterval(() => {
        callback();
      }, 3000);
      this.intervals.set(id, interval);
    }
  }

  completeRefetch(id: string) {
    this.subscribers.delete(id);
    const interval = this.intervals.get(id);
    if (interval) {
      clearInterval(interval);
      this.intervals.delete(id);
    }

    if (this.currentId === id) {
      this.currentId = undefined;
      const nextId = [...this.subscribers.keys()][0];
      if (nextId) {
        this.startRefetch(nextId);
      }
    }
  }
}
